
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i2wg_9x5ck_39",
  "dismiss-button": "awsui_dismiss-button_1i2wg_9x5ck_71",
  "dismiss-button-inline": "awsui_dismiss-button-inline_1i2wg_9x5ck_116",
  "icon": "awsui_icon_1i2wg_9x5ck_126",
  "icon-inline": "awsui_icon-inline_1i2wg_9x5ck_132",
  "token-normal": "awsui_token-normal_1i2wg_9x5ck_137",
  "token-inline": "awsui_token-inline_1i2wg_9x5ck_144",
  "token-option-inline": "awsui_token-option-inline_1i2wg_9x5ck_170",
  "token-box": "awsui_token-box_1i2wg_9x5ck_174",
  "token-box-without-dismiss": "awsui_token-box-without-dismiss_1i2wg_9x5ck_193",
  "token-box-inline": "awsui_token-box-inline_1i2wg_9x5ck_197",
  "disable-padding": "awsui_disable-padding_1i2wg_9x5ck_217",
  "token-box-readonly": "awsui_token-box-readonly_1i2wg_9x5ck_224",
  "token-box-disabled": "awsui_token-box-disabled_1i2wg_9x5ck_225"
};
  